module.exports = {
  "country": "FR",
  "artist": "Frida Boccara",
  "song": "Un jour, un enfant",
  "year": "1969",
  "place": "1",
  "spotify": "69xpLjmW3DotKSpI7LaN7j"
};